import esMessages from '../locales/es_ES';
import FeaturesLocals from 'features/configs/l10n';

const EsLang = {
  messages: {
    ...esMessages,
    ...FeaturesLocals.es
  },
  locale: 'es-ES',
};
export default EsLang;
